import axios from "axios";
import { API } from "./api";

// Admin session is stored in a SEPARATE localStorage key from the user JWT.
// Both can coexist in the same browser. Never collide them.
const ADMIN_TOKEN_KEY = "regulens_admin_jwt";
const ADMIN_EXP_KEY = "regulens_admin_jwt_exp";

// ---- Constraint 1 ----
// Admin JWT lifetime is explicitly 60 minutes. Every session-related
// frontend timer must reference this value as the single source of truth.
export const ADMIN_JWT_LIFETIME_SECONDS = 60 * 60;
export const ADMIN_JWT_LIFETIME_MS = ADMIN_JWT_LIFETIME_SECONDS * 1000;
// Warning banner appears when this many seconds remain (5 minutes).
export const ADMIN_SESSION_WARN_THRESHOLD_SECONDS = 5 * 60;

export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY);
export const getAdminExp = () => localStorage.getItem(ADMIN_EXP_KEY);
export const setAdminSession = (token, expiresAt) => {
  localStorage.setItem(ADMIN_TOKEN_KEY, token);
  localStorage.setItem(ADMIN_EXP_KEY, expiresAt);
};
export const clearAdminSession = () => {
  localStorage.removeItem(ADMIN_TOKEN_KEY);
  localStorage.removeItem(ADMIN_EXP_KEY);
};

export const adminApi = axios.create({ baseURL: API });

adminApi.interceptors.request.use((config) => {
  const t = getAdminToken();
  if (t) config.headers["X-Admin-Token"] = t;
  return config;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearAdminSession();
    }
    return Promise.reject(err);
  },
);

// Convenience helper for components that need to react to remaining seconds.
export const secondsUntilAdminExpiry = () => {
  const exp = getAdminExp();
  if (!exp) return 0;
  const ms = new Date(exp).getTime() - Date.now();
  return Math.max(0, Math.floor(ms / 1000));
};
